(() => {
  'use strict';

  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const centerActiveLink = () => {
    if (window.innerWidth > 990) return;
    document.querySelectorAll('.c1l-nav-links').forEach((scroller) => {
      const active = scroller.querySelector('.c1l-nav-link.is-active');
      if (!active) return;
      const left = active.offsetLeft - (scroller.clientWidth - active.offsetWidth) / 2;
      scroller.scrollTo({ left: Math.max(0, left), behavior: reducedMotion() ? 'auto' : 'smooth' });
    });
  };

  let centerFrame = 0;
  const scheduleCenterActiveLink = () => {
    if (centerFrame) return;
    centerFrame = window.requestAnimationFrame(() => {
      centerFrame = 0;
      centerActiveLink();
    });
  };

  const observeNavigation = () => {
    document.querySelectorAll('.c1l-nav-links').forEach((nav) => {
      if (nav.dataset.c1PremiumObserved === 'true') return;
      nav.dataset.c1PremiumObserved = 'true';
      const observer = new MutationObserver((records) => {
        if (records.some((record) => record.attributeName === 'class')) scheduleCenterActiveLink();
      });
      observer.observe(nav, { subtree: true, attributes: true, attributeFilter: ['class'] });
    });
    scheduleCenterActiveLink();
  };

  const normalizeRoiProductCopy = (root = document) => {
    const products = [];
    if (root instanceof Element && root.matches('[data-roi-product]')) products.push(root);
    root.querySelectorAll?.('[data-roi-product]').forEach((item) => products.push(item));
    products.forEach((item) => {
      if ((item.dataset.name || '').trim() !== 'Tumblr') return;
      item.dataset.name = 'Tumbler';
      const label = item.querySelector('.c1roi-v2__product-name');
      if (label) label.textContent = 'Tumbler';
      item.querySelectorAll('img').forEach((img) => {
        if ((img.alt || '').trim() === 'Tumblr') img.alt = 'Tumbler';
      });
    });
  };

  const resetCustomRoi = (trigger) => {
    const roi = trigger?.closest('[data-c1-product-roi]') || document.querySelector('[data-c1-product-roi]');
    if (!roi) return;
    const customTile = roi.querySelector('[data-roi-custom-product]');
    const products = [...roi.querySelectorAll('[data-roi-product]')];
    const price = roi.querySelector('[data-roi-v2-price]');
    const cost = roi.querySelector('[data-roi-v2-cost]');
    const sales = roi.querySelector('[data-roi-v2-sales]');
    const overhead = roi.querySelector('[data-roi-v2-overhead]');
    const selectedName = roi.querySelector('[data-roi-selected-name]');

    roi.classList.add('is-custom-mode');
    products.forEach((item) => {
      const active = item === customTile;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    [price, cost, sales, overhead].forEach((input) => {
      if (!input) return;
      input.min = '0';
      input.value = '0';
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });

    if (selectedName) selectedName.textContent = roi.dataset.customProductLabel || '';
  };

  const installRoiCustomReset = () => {
    if (document.documentElement.dataset.c1RoiCustomReset === 'true') return;
    document.documentElement.dataset.c1RoiCustomReset = 'true';

    document.addEventListener('click', (event) => {
      const preset = event.target.closest('[data-roi-product]:not([data-roi-custom-product])');
      if (preset) preset.closest('[data-c1-product-roi]')?.classList.remove('is-custom-mode');

      const trigger = event.target.closest('[data-roi-custom-shortcut], [data-roi-custom-product]');
      if (!trigger) return;
      window.setTimeout(() => resetCustomRoi(trigger), 0);
    });
  };

  const closeHeroModal = (modal) => {
    if (!modal) return;
    if (window.C1HeroVideoController && typeof window.C1HeroVideoController.close === 'function') {
      window.C1HeroVideoController.close(modal);
      return;
    }

    const modalVideo = modal.querySelector('video.c1l-hero-video-full');
    const modalIframe = modal.querySelector('[data-c1-hero-video-iframe]');
    try {
      if (modalVideo) {
        modalVideo.pause();
        modalVideo.currentTime = 0;
      }
    } catch (error) {}
    if (modalIframe) modalIframe.setAttribute('src', 'about:blank');

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    modal.hidden = true;
    document.documentElement.classList.remove('c1l-hero-video-modal-open');
    document.body.classList.remove('c1l-hero-video-modal-open');
    document.documentElement.style.removeProperty('overflow');
    document.body.style.removeProperty('overflow');
  };

  const isHeroModalOpen = (modal) => {
    if (!modal || modal.hidden) return false;
    if (modal.getAttribute('aria-hidden') === 'true') return false;
    return modal.classList.contains('is-open') || modal.getAttribute('aria-hidden') === 'false';
  };

  const setImportantStyles = (node, styles) => {
    Object.entries(styles).forEach(([property, value]) => {
      node.style.setProperty(property, value, 'important');
    });
  };

  const enhanceHeroModal = (modal) => {
    if (!modal || modal.dataset.c1BodyCloseReady === 'true') return;
    modal.dataset.c1BodyCloseReady = 'true';
    modal.querySelectorAll('[data-c1-hero-video-root-close]').forEach((node) => node.remove());

    const closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'c1l-hero-video-floating-close';
    closeButton.setAttribute('data-c1-hero-video-floating-close', '');
    const i18n = document.querySelector('[data-c1-shell]')?.dataset || {};
    closeButton.setAttribute('aria-label', i18n.closeVideoLabel || '');
    closeButton.setAttribute('title', i18n.closeLabel || '');
    closeButton.textContent = '×';

    setImportantStyles(closeButton, {
      position: 'fixed',
      top: '16px',
      left: '16px',
      right: 'auto',
      width: '46px',
      height: '46px',
      'min-width': '46px',
      'min-height': '46px',
      padding: '0',
      margin: '0',
      border: '1px solid rgba(0,0,0,.16)',
      'border-radius': '999px',
      background: '#ffffff',
      color: '#111111',
      'font-family': 'Arial, Helvetica, sans-serif',
      'font-size': '30px',
      'font-weight': '300',
      'line-height': '42px',
      'text-align': 'center',
      'box-shadow': '0 10px 30px rgba(0,0,0,.28)',
      cursor: 'pointer',
      'touch-action': 'manipulation',
      'user-select': 'none',
      '-webkit-user-select': 'none',
      'z-index': '2147483647',
      transform: 'none',
      filter: 'none'
    });

    document.body.appendChild(closeButton);

    const positionCloseButton = () => {
      if (!isHeroModalOpen(modal)) return;
      const player = modal.querySelector('.c1l-hero-video-player');
      if (!player) return;

      const rect = player.getBoundingClientRect();
      const mobile = window.innerWidth <= 749;
      const size = mobile ? 40 : 44;
      const inset = mobile ? 8 : 12;
      const edge = 8;
      const top = Math.max(edge, Math.min(window.innerHeight - size - edge, rect.top + inset));
      const left = Math.max(edge, Math.min(window.innerWidth - size - edge, rect.right - size - inset));

      setImportantStyles(closeButton, {
        top: `${Math.round(top)}px`,
        left: `${Math.round(left)}px`,
        right: 'auto',
        width: `${size}px`,
        height: `${size}px`,
        'min-width': `${size}px`,
        'min-height': `${size}px`,
        'font-size': mobile ? '27px' : '29px',
        'line-height': `${size - 4}px`
      });
    };

    const syncCloseButton = () => {
      const open = isHeroModalOpen(modal);
      setImportantStyles(closeButton, {
        display: open ? 'block' : 'none',
        visibility: open ? 'visible' : 'hidden',
        opacity: open ? '1' : '0',
        'pointer-events': open ? 'auto' : 'none'
      });
      if (open) {
        closeButton.removeAttribute('hidden');
        window.requestAnimationFrame(positionCloseButton);
      } else {
        closeButton.setAttribute('hidden', '');
      }
    };

    closeButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      closeHeroModal(modal);
      window.requestAnimationFrame(syncCloseButton);
    });

    modal.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (target.closest('.c1l-hero-video-player')) return;
      closeHeroModal(modal);
    }, true);

    modal.addEventListener('pointerup', (event) => {
      if (event.pointerType !== 'touch') return;
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (target.closest('.c1l-hero-video-player')) return;
      closeHeroModal(modal);
    }, true);

    const observer = new MutationObserver(syncCloseButton);
    observer.observe(modal, {
      attributes: true,
      attributeFilter: ['class', 'hidden', 'aria-hidden', 'style']
    });

    window.addEventListener('resize', () => {
      if (isHeroModalOpen(modal)) window.requestAnimationFrame(positionCloseButton);
    }, { passive: true });

    window.addEventListener('orientationchange', () => {
      if (isHeroModalOpen(modal)) window.setTimeout(positionCloseButton, 120);
    }, { passive: true });

    syncCloseButton();
  };

  const installHeroModalRecovery = (root = document) => {
    const modals = [];
    if (root instanceof Element && root.matches('[data-c1-hero-video-modal]')) modals.push(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('[data-c1-hero-video-modal]').forEach((modal) => modals.push(modal));
    }
    modals.forEach(enhanceHeroModal);
  };

  const init = (root = document) => {
    observeNavigation();
    normalizeRoiProductCopy(root);
    installRoiCustomReset();
    installHeroModalRecovery(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target || document);
  });

  window.addEventListener('resize', scheduleCenterActiveLink, { passive: true });
})();
